import React from 'react';
import { useContext } from 'react';
import {IProps} from './types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { Context } from '@routes/private/Editor/Context';
import { IDSConfig } from '@state/dsconfig/types';
import MultiLeveMenu from '@components/MultiLeveMenu';


const Menu:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  
  const handleClickCategory = (field: any) => {
    if (field) {
      context.onSelectDescribeCategoryAdd(field.id, field.name);
      props.closeMenu();
    }
  }

  return (
    <>
    {dsConfig?.selectDescribeConfig && dsConfig?.selectDescribeConfig.categories &&
      <MultiLeveMenu 
          fields = {dsConfig?.selectDescribeConfig.categories}
          onClick={(field: any) => handleClickCategory(field)} 
          position={props.position}
          limits={props.limits}
          closeMenu={props.closeMenu}
      />
    }
    </>
  );
}

export default Menu;